import { useCallback } from 'react';
import { DetailedItem } from 'src/features/common/models';
import { useTreeTableRefetchContext } from 'src/features/shared/treeTable/components/TreeTableRefetchContext';

export const useRenameItemButtonItemView = () => {
  const refreshTable = useTreeTableRefetchContext();

  return useCallback((item: DetailedItem) => refreshTable(item.itemId), [refreshTable]);
};
